export default __webpack_public_path__ + "static/media/logo.60bde6e2.svg";